import styled, { css, keyframes } from "styled-components";
import { styled as muiStyled } from "@mui/material/styles";
import { Box, Badge, IconButton, Button, FormControlLabel } from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";

const filterIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(14px) scale(0.92);
    filter: blur(4px);
  }
  to {
    opacity: 1;
    transform: none;
    filter: none;
  }
`;

const filterOut = keyframes`
  from {
    opacity: 1;
    transform: none;
    filter: none;
  }
  to {
    opacity: 0;
    transform: translateY(8px) scale(0.94);
    filter: blur(4px);
  }
`;

export const AnimatedFilter = styled.div`
  min-width: 0;
  animation: ${({ $isLeaving }) => ($isLeaving ? css`${filterOut} 220ms cubic-bezier(0.4, 0, 1, 1) both` : css`${filterIn} 420ms cubic-bezier(0.34, 1.56, 0.64, 1) both`)};
  animation-delay: ${({ $delay }) => $delay}ms;

  & > * {
    width: 100%;
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

// "+" that springs into a "×" when the extra filters are open
export const ToggleIcon = styled(AddIcon)`
  transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  transform: ${({ $isOpen }) => ($isOpen ? "rotate(135deg)" : "none")};

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const Container = muiStyled("div")(() => ({
  "&.MuiModal-root.MuiDialog-root": {
    zIndex: 1301,
  },
  "& .MuiSvgIcon-root.MuiSvgIcon-colorAction": {
    color: "var(--dp-muted)",
  },
  "& .MuiAutocomplete-popped": {
    zIndex: 1302,
  },
  padding: "4px 5px",
  width: "100%",
}));

export const IconButtonStyled = muiStyled(IconButton)(() => ({
  fontSize: "0.875rem",
  lineHeight: "1.43",
  color: "var(--dp-muted)",
  textTransform: "uppercase",
  fontWeight: 500,
  minWidth: "64px",
  borderRadius: "4px",
}));

export const StyledBadge = muiStyled(Badge)(({ theme, nbBadge = 0 }) => ({
  "& .MuiBadge-badge": {
    right: -3,
    top: 13,
    border: `2px solid ${theme.palette.background.paper}`,
    padding: "0 4px",
    backgroundColor: "var(--dp-primary)",
    color: "var(--dp-primary-contrast)",
    transition: "backgroundColor 0.3s",
  },
}));

export const ContainerButton = muiStyled(Box)(() => ({
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "flex-end",
}));

export const SeeMoreFiltersButton = styled(Button)({
  height: "40px",
  border: "1px dashed var(--dp-border-strong) !important",
  backgroundColor: "transparent !important",
  color: "var(--dp-muted) !important",
  textTransform: "none !important",
  boxShadow: "none !important",

  "&:hover": {
    color: "var(--dp-text) !important",
    borderColor: "var(--dp-muted) !important",
  },
});

export const ContainerFilters = styled.form`
  gap: 8px;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  width: 100%;
  padding-block: 4px;

  .MuiInputBase-root.MuiOutlinedInput-root,
  .MuiPickersInputBase-root.MuiPickersOutlinedInput-root {
    background-color: var(--dp-surface);
  }

  .MuiFormLabel-root.MuiInputLabel-root {
    color: var(--dp-muted);
  }

  .MuiFormControl-root.MuiPickersTextField-root {
    height: 40px;
  }

  .MuiPickersInputBase-root.MuiPickersOutlinedInput-root {
    height: 100%;
  }

  .MuiPickersTextField-root .MuiFormLabel-root.MuiInputLabel-root:not(.Mui-focused):not(.MuiFormLabel-filled) {
    transform: translate(14px, 10px) scale(1);
  }
`;

export const TopProjectCheckbox = muiStyled(FormControlLabel)({
  margin: 0,
});
